module.exports = __webpack_public_path__ + "static/img/Olivier-Blum_2017-18.135c0f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Olivier-Blum_2017-18.jpg
// module id = PS3e
// module chunks = 0